import type { AppModule } from '@shared/presentation/router/composition.js';
import { identityModules } from './identity/index.js';
import { platformModules } from './platform/index.js';
import { virtualProfilerModules } from './virtual-profiler/index.js';

/**
 * Application module registry.
 *
 * It only composes contexts: a new feature is registered in its context's
 * `index.ts`, not here. Order matters for one thing — the shell's host route
 * (`platform`) must exist before routes are hung off it.
 */
export const appModules: AppModule[] = [
  ...platformModules,
  ...identityModules,
  ...virtualProfilerModules,
];
